 import React from 'react';
import css from './KontaktInfo.module.css';

const KontaktInfo = () => {
    return (
        <section className={css.contactSection}>
            <div className={css.contactContainer}>
                <div className={css.contactItem}>
                    <div className={css.icon}>🕒</div>
                    <h3 className={css.title}>REJESTRACJA TELEFONICZNA </h3>
                    <p className={css.text}><a href="tel:519780316" className={css.link}>tel. 519 780 316</a></p>
                </div>

                <div className={css.separator}></div>
                <div className={css.contactItem}>
                    <div className={css.icon}>📞</div>
                    <h3 className={css.title}>PSYCHOLOG DAWID LEWKO </h3>
                    <p className={css.text}><a href="tel:517340729" className={css.link}>tel. 517 340 729</a></p>
                    <p className={css.text}><a href="mailto:psycholog.lewkodawid@interia.pl" className={css.link}>psycholog.lewkodawid@interia.pl</a></p>
                </div>

                <div className={css.separator}></div>

                <div className={css.contactItem}>
                    <div className={css.icon}>📍</div>
                    <h3 className={css.title}>Adres</h3>
                    <p className={css.text}>Zielona Góra<br /> ul.Bohaterów Westerplatte11 <br /> pokój 302 III PIĘTRO</p>
                </div>
            </div>
        </section>
    );
};

export default KontaktInfo;